import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rowResource: {
    width: '30%',
  },
  generateRowRoot: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-start',
  },
  pricingBuyer: {
    marginTop: '19px',
    float: 'right',
  },
  root: {
    padding: theme.spacing(3, 4),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  elementsGap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  sectionText: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
  },
  resourceRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  resourcesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  resouceField: {
    width: '49%',
  },
  trashIcon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    paddingTop: theme.spacing(2.25),
    width: '2%',
  },
  buttonSubText: {
    color: theme.palette.textField.main,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  widthButton: {
    width: 'fit-content',
    marginBottom: '8px',
    fontSize: '14px',
  },
  totalText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.textField.dark,
    marginTop: '8px',
  },
  totalTextHeading: {
    fontSize: '12px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  border: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  titleWraper: {
    display: 'flex',
    gap: '32px',
  },
  lowerWrapper: {
    marginTop: theme.spacing(0.5),
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    marginBottom: theme.spacing(-3),
  },
  generateBtn: {
    '& .MuiButton-root': {
      height: '44px',
    },
    '& .Mui-disabled': {
      height: '44px',
    },
  },
  installmentsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '100%',
  },
  currency: {
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontSize: '14px',
  },
  price: {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: theme.spacing(-1),
  },
  fixedTcvWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
  },
  radioSelection: {
    width: 'fit-content',
  },
  columnTextValue: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.textField.dark,
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  textAlignRight: {
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
  },
  metricsRow: {
    display: 'flex',
    gap: theme.spacing(6),
    flexWrap: 'wrap',
    marginTop: theme.spacing(0.5),
  },
  metricItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}))
